export default {
    path: '/',
    name: 'Reoprt',
    component: resolve => require(['@/views/report'], resolve),
    redirect: '/report', 
    children: [
        {
            path: '/report',
            name: 'report',
            meta: [{
                path: '/report',
                title: '报告',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/report.vue'], resolve),
        },
    ],
}